export default "__VITE_ASSET__c8fOkNgr__"